/** The kind of a marketplace entity in the words the pages use — a daemon is listed as workforce. */
export function marketplaceEntityLabel(entityType: string): string {
  if (entityType === 'daemon' || entityType === 'workforce') return 'workforce';
  return entityType.replaceAll('_', ' ');
}
